import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { global } from '../../shared/global';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  Login(data)
  {
    return this.http.post(global.baseAPIUrl + 'Login/UserLogin', data, global.httpOptions);
  }
  forgetPassword(data)
  {
    return this.http.post(global.baseAPIUrl + 'Login/forgetPassword', data, global.httpOptions);
  }
  changePassword(data)
  {
    if(localStorage.getItem("cd") == ")(*&"){
      return this.http.post(global.baseAPIUrl + 'Login/changePassword', data, global.httpOptions);
    }
    if(localStorage.getItem("cd") == "$#@!"){
      return this.http.post(global.baseAPIUrl + 'Login/changeUserPassword', data, global.httpOptions);
    }
  }
}
